import { Component } from 'react';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { CardSection, CardWrapper } from 'foundations-components/transitional/components/Card';
import { getTextColor } from 'MeetingsBase/utils/color';
import styled, { withTheme } from 'foundations-theming/utils';
import { Spacer } from 'foundations-components/components/Spacer';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const StyledCardContainer = styled.div.withConfig({
  displayName: "ColoredCard__StyledCardContainer",
  componentId: "pdngdz-0"
})(["background-color:", ";background-image:none;color:", ";margin-block-end:0;height:", ";"], props => props.backgroundColor, props => props.textColor, props => props.compact ? 'auto' : '100% !important');
class ColoredCard extends Component {
  constructor(...args) {
    super(...args);
    this.getPrimaryColorToUse = () => {
      const {
        branding: {
          primaryColor
        }
      } = this.props;
      return primaryColor;
    };
    this.getTextColorToUse = () => {
      const {
        branding: {
          primaryColor
        },
        theme
      } = this.props;
      return getTextColor(primaryColor, theme);
    };
  }
  render() {
    const {
      children,
      isSalesStarter,
      compact
    } = this.props;
    const primaryColorToUse = this.getPrimaryColorToUse();
    const textColorToUse = this.getTextColorToUse();
    return /*#__PURE__*/_jsx(CardWrapper, {
      borderRadius: "0",
      children: /*#__PURE__*/_jsx(StyledCardContainer, {
        backgroundColor: primaryColorToUse,
        textColor: textColorToUse,
        compact: compact,
        children: /*#__PURE__*/_jsxs(CardSection, {
          paddingInline: "0",
          paddingBlock: isSalesStarter ? '1100' : '800',
          display: "flex",
          flexDirection: "column",
          flex: "1",
          justifyContent: "center",
          blockSize: "100%",
          children: [/*#__PURE__*/_jsx(TFlex, {
            paddingBlockEnd: "100",
            direction: "column",
            justifyContent: "center",
            blockSize: "100%",
            children: children
          }), /*#__PURE__*/_jsx(Spacer, {
            space: "1000"
          })]
        })
      })
    });
  }
}
export default withTheme(ColoredCard);